module.exports = __webpack_public_path__ + "20250721160708/img/production.2e0c8196.png";